import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const waiverQuestionMutations: UpdatesConfig['Mutation'] = {
  waiverQuestionCreate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('waiverQuestions', cache);
  },
  waiverQuestionStatusUpdate: (_: Data, __: Variables, cache: Cache) => {
    invalidateQuery('waiverQuestions', cache);
  },
};

export default waiverQuestionMutations;
